export interface StoreModel<T> {
  isLoading?: boolean;
  isLoaded?: boolean;
  error?: any;
  data?: T;
}

export class StoreModelItem {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  data: any[];

  constructor(isLoading: boolean = false, isLoaded: boolean = false, data: any[] = [], error: any = null) {
    this.isLoading = isLoading;
    this.isLoaded = isLoaded;
    this.error = error;
    this.data = data;
  }
}
